import React, { useState, useEffect } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {  Modal } from 'antd';
import FilterSelect from "components/Form/filterSelect";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import {customStyleSelect } from "utils/common";
import useUploadHook from "components/uploadHook";
import {  statusChangeResumeApi } from "api/services/resume";
import {  toast, Bounce } from 'react-toastify';
import {format} from "date-fns"
import { Button } from "components/Button";
import { useSelector } from "react-redux";
import { jobStatusOptions } from "utils/constants";
import EssFullWidthModal from "components/modelpopup/baseModal"

const EmployeeLeaveModelPopup = (props) => {

  const resumeStatusSchema = Yup.object().shape({
    status: Yup.object().required('Status is required'), 

  });


  const [loading, setLoading] = useState(false);
  const [userOption, setUserOption] = useState([]);


  // const statusOptions = [
  //   {label:"Approved", value: "approved"},
  //   {label:"Rejected", value: "rejected"}
  // ]
  const {
    uploadLoading,
    handleFile
  } = useUploadHook()
  const {

    userData, userDataLoading
   
} = useSelector((state) => state.common);



  const {
    control: statusControl,
    handleSubmit: handleStatusSubmit,
    formState: { errors: statusError },
    setValue: setStatusValue,
    reset  : statusReset,
    setError: setStatusError
  } = useForm({
    resolver: yupResolver(resumeStatusSchema), 
    defaultValues: {
      
    },
  });
  


  

  useEffect(()=>{
    if(props?.selectedResume?.id){
      console.log(props?.selectedResume, "HHHHH")
      let approvalStatus = jobStatusOptions.find(item=> item.value == props.selectedResume.status)
      console.log(approvalStatus, jobStatusOptions,props.selectedResume.status, "JJJJ")
      setStatusValue("status", approvalStatus)

    }else{
      statusReset()
    }
  }, [props.selectedResume])

  useEffect(()=>{
   
    if(userData){
      let users = userData.map(item=> {
        return{
            label: `${item.first_name} ${item.last_name}`,
            value: item.id
        }
    })
    setUserOption(users)
    }
  
  
  },[userData])

  
  

   const onStatusChange = (data) => {
    console.log(data, "LLLLL")
    data['status'] = data?.status?.value
    statusChangeResumeApi(data, props.selectedResume?.id).then(response=>{
      setLoading(false)

      toast.success('Applicant status updated!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
        props.setResumeStatusModal(false)
        props.setSelectedResume("")
        statusReset()
        props.getResumeList()

      console.log(response, "REEEEEE")
    }).catch(e=> {
      console.log(e, "eee")
      try{
        console.log(e.response.data, "EEEEE")
        // let response = e.response?.data?.error || "Error updating leave status!"
        setLoading(false)
          // toast.error(response, {
          //   position: "top-right",
          //   autoClose: 5000,
          //   hideProgressBar: false,
          //   closeOnClick: false,
          //   pauseOnHover: true,
          //   draggable: true,
          //   progress: undefined,
          //   theme: "light",
          //   transition: Bounce,
          //   });

      if(e.response.data){
        Object.entries(e.response.data).forEach(([k, v]) => {
          console.log(typeof v,k, "EEEEE")
          setStatusError(k,
            {
              type: 'manual',
              message: v.join(", ")
            }
             )
        })
      }
      }catch(err){
        console.log(err, "LLLLLLL")
        let response = e.response?.data?.error || "Error updating resume status!"
        setLoading(false)
          toast.error(response, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
        
      }



      
    })


   }
 

  return (
    <>
    <EssFullWidthModal
        mask={false}
        title={"Change applicant status"}
              // style={{ top: 100 }}
              open={props.resumeStatusModal}
              width={"40%"}
              footer={[]}     
              onCancel={() => {
                statusReset()
                statusReset()
                props?.setSelectedResume("")
                props.setResumeStatusModal(false)
              }}
                className="full-width-modal"


            >

       
              
          <div className="modal-content">
            {/* <div className="modal-header">
              <h5 className="modal-title">Add Leave</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div> */}
            <div className="modal-body">
          
                <form  onSubmit={handleStatusSubmit(onStatusChange)}>
        

                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Status <span className="text-danger">*</span>
                  </label>
                  <Controller
                        name={`status`}
                        // name={"assignee"}
                        control={statusControl}
                        // defaultValue=""
                        // rules={{ required: 'Select a contact' }}
                        render={({ field }) => (
                          <>
                            <FilterSelect 
                            isClearable={true} 
                            onChange={(e) => {
                              field.onChange(e);
                            }}
                            optionLabel={"label"} 
                            optionValue={'value'} 
                            options={jobStatusOptions}
                            value={field.value}
                              placeholder={"Status Type"}
                              styles={customStyleSelect}
                              isLoading={false}
                              />

                           
                          </>
                        )}
                      />
                      {statusError.status && (
                        <small className="text-danger">
                          {statusError.status?.message}
                        </small>
                      )}

                </div>
              
        
               

                <div className="submit-section">
                <Button
                  loading={loading}
                  disabled={loading}
                    className="btn btn-primary submit-btn"             
                    type="submit"
                    label="Submit"
                  />
                </div>
              </form>
           
            </div>
          </div>
          </EssFullWidthModal>

    </>
  );
};

export default EmployeeLeaveModelPopup;
